module.exports = __webpack_public_path__ + "static/media/img14.e3beaa9f.jpg";